const priceChangesConstants = {
	CHECK_REORG_MATERIALS_PERIOD_CHANGES: {
		FAILURE : 'CHECK_REORG_MATERIALS_PERIOD_CHANGES_FAILURE',
		REQUEST : 'CHECK_REORG_MATERIALS_PERIOD_CHANGES_REQUEST',
		SUCCESS : 'CHECK_REORG_MATERIALS_PERIOD_CHANGES_SUCCESS'
	},
	GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES: {
		FAILURE : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FAILURE',
		REQUEST : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_REQUEST',
		SUCCESS : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_SUCCESS'
	},
	GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE: {
		FAILURE : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE_FAILURE',
		REQUEST : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE_REQUEST',
		SUCCESS : 'GET_EMPTY_REORG_MATERIALS_PERIOD_PRICE_CHANGES_FILE_SUCCESS'
	},
	GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE: {
		FAILURE : 'GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE_FAILURE',
		REQUEST : 'GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE_REQUEST',
		SUCCESS : 'GET_INDEXES_FOR_REORG_MATERIALS_PERIOD_PRICE_SUCCESS'
	},
	CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES: {
		FAILURE : 'CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES_FAILURE',
		REQUEST : 'CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES_REQUEST',
		SUCCESS : 'CALCULATE_INDEX_FOR_REORG_MATERIAL_BY_CATEGORIES_SUCCESS'
	},
	ADD_RESULT_FOR_EMPTY_REGION_DATA: {
		FAILURE : 'ADD_RESULT_FOR_EMPTY_REGION_DATA_FAILURE',
		REQUEST : 'ADD_RESULT_FOR_EMPTY_REGION_DATA_REQUEST',
		SUCCESS : 'ADD_RESULT_FOR_EMPTY_REGION_DATA_SUCCESS'
	}
}

export default priceChangesConstants